import { useState } from "react";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import { changeTabActive } from "../redux/actions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

const NavBar = ({ activeTab }) => {
  const dispatch = useDispatch();
  const [linkNav] = useState([
    { text: "Главная", ref: "/#heading" },
    { text: "Проекты", ref: "/#projects" },
    { text: "Сертификаты", ref: "certificates" },
    { text: "Отзывы", ref: "reviews" },
    { text: "Контакты", ref: "/#contacts" },
  ]);
  const [statusNav, changeStatusNav] = useState(null);
  const toggleNav = () => {
    changeStatusNav(statusNav === null ? "active" : null);
  };
  const changeTab = (value) => {
    dispatch(changeTabActive(value));
    toggleNav();
  };
  return (
    <header>
      <div className="logo">
        <img
          src="https://raw.githubusercontent.com/YgamiJS/YgamiJS/main/src/img/avatar.webp"
          fetchpriority="low"
          loading="lazy"
          width={50}
          height={50}
          alt=""
        />
        Дмитрий | Портфолио
      </div>
      <nav className={statusNav}>
        {linkNav.map((value) => (
          <a
            href={`${value.ref}`}
            key={value.text}
            className={activeTab === value ? "active" : ""}
            onClick={() => changeTab(value.text)}
          >
            {value.text}
          </a>
        ))}
      </nav>
      <div className="icon-bar" onClick={toggleNav}>
        <FontAwesomeIcon icon={faBars} />
      </div>
    </header>
  );
};
const mapStateToProps = (state) => ({
  activeTab: state.activeTab,
});

export default connect(mapStateToProps, { changeTabActive })(NavBar);
